module.exports = __webpack_public_path__ + "img/1.48da3fad.png";